import { useUser } from "../../../util/userContext/UserContext";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import useGoToNavigation from "../../../util/useGotoNavigation";

const internalUrl: string[] = [
    "main/dashboard",
    "main/sales",
    "main/overseas",
    "main/exchange",
    "order/orderRequest",
    "order/orders",
    "order/deadline",
    "order/invoice",
    "order/receivables",
    "inventory/inv",
    "inventory/incoming",
    "inventory/outgoing",
    "inventory/adjustment",
    "inventory/history",
    "inventory/analyze",
    "inventory/barcode",
    "customer/correspondent",
    "customer/contact",
    "customer/project",
    "customer/tier",
    "support/faq",
    "support/qna",
    "support/rma",
    "support/board",
    "manage/account",
    "manage/role",
    "manage/items",
    "manage/mypage",
    "product",
]

const externalUrl: string[] = [
    "main/exchange",
    "purchase/pcs",
    "purchase/delivery",
    "support/faq",
    "support/qna",
    "support/board",
    "manage/company",
    "manage/mypage",
    "product",
]

export default function RouteProtector() {
    const { pathname } = useLocation()
    const { user } = useUser()
    const { goToNavigation } = useGoToNavigation();

    useEffect(() => {
        if (user) {
            switch (user.inOutFlag) {
                case 0:
                    !internalUrl.some(url => pathname.includes(url)) && goToNavigation("not_found", {}, false);
                    break;
                case 1:
                    !externalUrl.some(url => pathname.includes(url)) && goToNavigation("not_found", {}, false);
                    break;
                default:
                    break;
            }
        }

        if (user) {
            if (!user.authority.salesReadYn || user.authority.salesReadYn === "N") {
                pathname.includes('sales/list') && goToNavigation("not_found", {}, false);
                pathname.includes('sales/expected') && goToNavigation("not_found", {}, false);
                pathname.includes('sales/column') && goToNavigation("not_found", {}, false);
                pathname.includes('sales/company') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.salesWriteYn || user.authority.salesWriteYn === "N") {
                pathname.includes('sales/expected') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.overseasReadYn || user.authority.overseasReadYn === "N") {
                pathname.includes('overseas/list') && goToNavigation("not_found", {}, false);
                pathname.includes('overseas/column') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.orderReadYn || user.authority.orderReadYn === "N") {
                pathname.includes('pcs/list') && goToNavigation("not_found", {}, false);
                pathname.includes('pcs/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('pcs/create') && goToNavigation("not_found", {}, false);
                pathname.includes('delivery/list') && goToNavigation("not_found", {}, false);
                pathname.includes('delivery/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('orderRequest/list') && goToNavigation("not_found", {}, false);
                pathname.includes('orderRequest/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('orderRequest/create') && goToNavigation("not_found", {}, false);
            }
            if (user.authority.orderWriteYn === "N") {
                pathname.includes('pcs/create') && goToNavigation("not_found", {}, false);
                pathname.includes('orderRequest/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.shipmentReadYn || user.authority.shipmentReadYn === "N") {
                pathname.includes('order/list') && goToNavigation("not_found", {}, false);
                pathname.includes('order/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('order/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.shipmentWriteYn || user.authority.shipmentWriteYn === "N") {
                pathname.includes('order/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.endReadYn || user.authority.endReadYn === "N") {
                pathname.includes('deadline/list') && goToNavigation("not_found", {}, false);
                pathname.includes('deadline/detail') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.taxReadYn || user.authority.taxReadYn === "N") {
                pathname.includes('invoice/list') && goToNavigation("not_found", {}, false);
                pathname.includes('invoice/detail') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.productReadYn || user.authority.productReadYn === "N") {
                pathname.includes('product/list') && goToNavigation("not_found", {}, false);
                pathname.includes('product/detail') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.inventoryReadYn || user.authority.inventoryReadYn === "N") {
                pathname.includes('inv/list') && goToNavigation("not_found", {}, false);
                pathname.includes('inv/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('inv/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.inventoryWriteYn || user.authority.inventoryWriteYn === "N") {
                pathname.includes('inv/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.inboundReadYn || user.authority.inboundReadYn === "N") {
                // InvHistory에서 관리
            }
            if (!user.authority.inboundWriteYn || user.authority.inboundWriteYn === "N") {
                pathname.includes('incoming/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.outboundReadYn || user.authority.outboundReadYn === "N") {
                // InvHistory에서 관리
            }
            if (!user.authority.outboundWriteYn || user.authority.outboundWriteYn === "N") {
                pathname.includes('outgoing/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.adjustmentReadYn || user.authority.adjustmentReadYn === "N") {
                // InvHistory에서 관리
            }
            if (!user.authority.adjustmentWriteYn || user.authority.adjustmentWriteYn === "N") {
                pathname.includes('adjustment/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.detailsReadYn || user.authority.detailsReadYn === "N") {
                pathname.includes('inventory/history') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.analysisReadYn || user.authority.analysisReadYn === "N") {
                pathname.includes('analyze/list') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.barcodeReadYn || user.authority.barcodeReadYn === "N") {
                pathname.includes('inventory/barcode') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.clientReadYn || user.authority.clientReadYn === "N") {
                pathname.includes('correspondent/list') && goToNavigation("not_found", {}, false);
                pathname.includes('correspondent/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('correspondent/beforeApproval') && goToNavigation("not_found", {}, false);
                pathname.includes('correspondent/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.clientWriteYn || user.authority.clientWriteYn === "N") {
                pathname.includes('correspondent/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.contactReadYn || user.authority.contactReadYn === "N") {
                pathname.includes('contact/list') && goToNavigation("not_found", {}, false);
                pathname.includes('contact/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('contact/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.contactWriteYn || user.authority.contactWriteYn === "N") {
                pathname.includes('contact/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.projectReadYn || user.authority.projectReadYn === "N") {
                pathname.includes('project/list') && goToNavigation("not_found", {}, false);
                pathname.includes('project/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('project/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.projectWriteYn || user.authority.projectWriteYn === "N") {
                pathname.includes('project/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.tierReadYn || user.authority.tierReadYn === "N") {
                pathname.includes('tier/list') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.faqReadYn || user.authority.faqReadYn === "N") {
                pathname.includes('faq/list') && goToNavigation("not_found", {}, false);
                pathname.includes('faq/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('faq/update') && goToNavigation("not_found", {}, false);
                pathname.includes('faq/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.faqWriteYn || user.authority.faqWriteYn === "N") {
                pathname.includes('faq/update') && goToNavigation("not_found", {}, false);
                pathname.includes('faq/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.qnaReadYn || user.authority.qnaReadYn === "N") {
                pathname.includes('qna/list') && goToNavigation("not_found", {}, false);
                pathname.includes('qna/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('qna/update') && goToNavigation("not_found", {}, false);
                pathname.includes('qna/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.qnaWriteYn || user.authority.qnaWriteYn === "N") {
                pathname.includes('qna/update') && goToNavigation("not_found", {}, false);
                // pathname.includes('qna/create')
            }

            if (!user.authority.rmaReadYn || user.authority.rmaReadYn === "N") {
                pathname.includes('rma/list') && goToNavigation("not_found", {}, false);
                pathname.includes('rma/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('rma/update') && goToNavigation("not_found", {}, false);
                pathname.includes('rma/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.rmaWriteYn || user.authority.rmaWriteYn === "N") {
                pathname.includes('rma/update') && goToNavigation("not_found", {}, false);
                pathname.includes('rma/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.boardReadYn || user.authority.boardReadYn === "N") {
                pathname.includes('board/list') && goToNavigation("not_found", {}, false);
                pathname.includes('board/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('board/update') && goToNavigation("not_found", {}, false);
                pathname.includes('board/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.boardWriteYn || user.authority.boardWriteYn === "N") {
                pathname.includes('board/update') && goToNavigation("not_found", {}, false);
                pathname.includes('board/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.accountReadYn || user.authority.accountReadYn === "N") {
                pathname.includes('account/list') && goToNavigation("not_found", {}, false);
                pathname.includes('account/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('account/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.accountWriteYn || user.authority.accountWriteYn === "N") {
                pathname.includes('account/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.roleReadYn || user.authority.roleReadYn === "N") {
                pathname.includes('role/list') && goToNavigation("not_found", {}, false);
                pathname.includes('role/detail') && goToNavigation("not_found", {}, false);
                pathname.includes('role/create') && goToNavigation("not_found", {}, false);
            }
            if (!user.authority.roleWriteYn || user.authority.roleWriteYn === "N") {
                pathname.includes('role/create') && goToNavigation("not_found", {}, false);
            }

            if (!user.authority.itemReadYn || user.authority.itemReadYn === "N") {
                pathname.includes('items') && goToNavigation("not_found", {}, false);
            }

        }
    }, [user, pathname]);
}